import { createFileRoute } from '@tanstack/react-router'

import { PlatformProductDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-product-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/products')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <PlatformProductDocumentationPage />
    </PermissionChecker>
  ),
})
